import { NgModule } from '@angular/core';
import { NgxMaskModule } from 'ngx-mask';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

/**Local component */
import { RegisterationComponent } from './registeration.component';
import { RegisterationFormComponent } from './register-form/register-form.component';

/**Service file */
import { AuthService } from '../auth.service';

/** Query file*/
import { UserQueryService, RolesQueryService } from '../../queryFiles/index';


const routes = [
    {
        path: 'registeration',
        component: RegisterationComponent,
        resolve: {
            auth: AuthService,
        }
    }
];

@NgModule({
    declarations: [
        RegisterationComponent,
        RegisterationFormComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        NgxMaskModule.forRoot()
    ],
    providers: [
        /**Service file */
        AuthService,
        /** Query file*/
        UserQueryService,
        RolesQueryService
    ],
})

export class RegisterationModule {

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/authentication/registration/registeration.module.ts